import {
  formatNumber,
  formatDate,
  formatTime,
  formatDateTime,
  formatDuration,
  formatDayMonth,
  formatlDayMonthYear,
  formatPeriod,
  calculateRealDuration,
  formatCoordinates,
  formatFileSize,
  formatBoolean,
  formatDaysUntil26Birthday,
} from "@/lib/utils/formatters";
import { useTranslation } from "react-i18next";

export const useFormatters = () => {
  const { t } = useTranslation();

  return {
    formatNumber,
    formatDate,
    formatTime,
    formatDateTime,
    formatDayMonth,
    formatlDayMonthYear,
    formatPeriod,
    formatDuration: (duration: Parameters<typeof formatDuration>[0]) => {
      return formatDuration(duration, t);
    },
    calculateRealDuration: (
      date: Parameters<typeof calculateRealDuration>[0],
      startTime: Parameters<typeof calculateRealDuration>[1],
    ) => {
      return calculateRealDuration(date, startTime, t);
    },
    formatCoordinates,
    formatFileSize,
    formatBoolean: (
      value: Parameters<typeof formatBoolean>[0],
      translationKey?: Parameters<typeof formatBoolean>[2],
    ) => {
      return formatBoolean(value, t, translationKey);
    },
    formatDaysUntil26Birthday,
  };
};

export type Formatters = ReturnType<typeof useFormatters>;
